import {
  BtnContainer,
  ButtonRedireccion,
  CruzContainer,
  Header,
  ModalBody,
  RedireccionContainer,
} from "./localStyle";

const RedirigirApp = ({ dissmiss, dniPaciente }) => {
  const config = localStorage.getItem("config");
  const configParse = JSON.parse(config);
  const { urlPlayStore, urlAppStore } = configParse;

  const continuarWeb = () => {
    const dniEncoded = btoa(dniPaciente);
    // const url = "http://localhost:8101/";
    const url = "https://portal.dim.com.ar/";
    // window.open(`${url}?autocheckQR=${dniEncoded}`, "_blank");
    window.location.href = `${url}?autocheckQR=${dniEncoded}`;

    dissmiss();
  };

  const abrirApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const deepLinkAndroid = `intent://app?dni=${dniPaciente}#Intent;scheme=portalturnos;package=ar.com.dim.portalturnos;end`;
    const storeAndroid = urlPlayStore;
    const deepLinkiOS = `fb1725490837765364://login?dni=${dniPaciente}`;
    const storeiOS = urlAppStore;

    if (/android/i.test(userAgent)) {
      alert(deepLinkAndroid);
      window.location.href = deepLinkAndroid;
      setTimeout(() => {
        // window.location.href = storeAndroid;
        window.open(storeAndroid, "_blank");
      }, 1000);
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href = deepLinkiOS;
      setTimeout(() => {
        window.location.href = storeiOS;
      }, 1000);
      // openDeepLink();
    } else {
      alert("Solo disponible para dispositivos móviles.");
    }
    dissmiss();
  };

  const openDeepLink = () => {
    const deepLinkiOS = `fb1725490837765364://login?dni=${dniPaciente}`;
    const storeiOS = urlAppStore;

    // Intentar abrir la app
    window.location.href = deepLinkiOS;

    // Esperamos apenas 300ms
    setTimeout(() => {
      // Si el documento sigue visible después de intentar abrir el deep link, vamos al store
      if (!document.hidden) {
        window.location.href = storeiOS;
      }
    }, 300); // 300ms o 400ms, no más
  };

  return (
    <RedireccionContainer>
      <Header>
        <span className="rb18m c-white">Atención</span>
        <CruzContainer onClick={dissmiss}>
          <div className="line1"></div>
          <div className="line2"></div>
        </CruzContainer>
      </Header>
      <ModalBody>
        <span className="rb16l c-black">
          ¿Querés gestionar tus turnos de forma más rápida y cómoda? Descargá
          nuestra app y hacelo en pocos pasos. Si preferís, también podés
          continuar desde la web.
        </span>
        <BtnContainer>
          <ButtonRedireccion
            onClick={continuarWeb}
            className="bgc-latex30 rb16m c-white"
          >
            Continuar vía web
          </ButtonRedireccion>
          <ButtonRedireccion
            onClick={abrirApp}
            className=" bgc-primary rb16m c-white"
          >
            Abrir App
          </ButtonRedireccion>
        </BtnContainer>
      </ModalBody>
    </RedireccionContainer>
  );
};

export default RedirigirApp;
